<template>
    <div class="row">
        <router-view name="routerviewadmin"></router-view>
    </div>
</template>

<script>
import charts from '@/data/charts.js'
export default {
    title: 'Voxo-Dashboad',
    data() {
        return {
            earningChart: charts.earningChart,
            revenueChart: charts.revenueChart,
            visitorChart: charts.visitorChart
        }
    }
}
</script>

<style></style>
